import styled from "styled-components";

// App wrapper styles

const AppWrapper = styled.div `
	
	padding: 20px; //changed margin to padding
	//min-height: 100vh;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: center;
	min-height: 100vh;

	//background-color: #DCB;
	
`;


export default AppWrapper;
